import React from 'react'
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export default function PaymentMethodBasicComponent({ 
  handleBasicInnerFormChange, chosenPaymentMethod, stores 
}: any) {
  
  return (
    <>
      <AccordionContainer
        child={
          <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="Store"
              labelField="StoreInfo.StoreName"
              list={stores}
              onValueChange={(event: any, newValue: any) => {
                handleBasicInnerFormChange(
                  event.target.value,
                  'StoreId',
                );
              }}
              optionName='Choose Store'
              type="select"
              value={chosenPaymentMethod?.StoreId}
              valueField="StoreInfo.Id"
            />
            <InputContainer
              label="Gateway Key"
              onValueChange={(event: any, newValue: any) => {
                handleBasicInnerFormChange(
                  event.target.value,
                  'GatewayKey',
                )
              }}
              type="text"
              value={chosenPaymentMethod?.GatewayKey}
            />
            <InputContainer
              label="Gateway Secret"
              onValueChange={(event: any, newValue: any) => {
                handleBasicInnerFormChange(
                  event.target.value,
                  'GatewaySecret',
                )
              }}
              type="text"
              value={chosenPaymentMethod?.GatewaySecret}
            />
          </div>
        }
        expandedPanel="BasicInfo"
        headerTitle="Basic Information"
      />

    </>
  )
}